import React from "react";
import styles from "./FlatSection.module.css";
import Button from "../common/button/button";

interface FlatSectionProps {
  alt: string;
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  imageSrc: string;
}

const FlatSection: React.FC<FlatSectionProps> = ({
  alt,
  title,
  description,
  buttonText,
  buttonLink,
  imageSrc,
}) => {
  return (
    <div className={`${styles.flatSection} `}>
      <div className={styles.imageContainer}>
        <img src={imageSrc} alt={alt} loading="lazy" className={styles.image} />
      </div>
      <div className={styles.overlay}>
        <div className={styles.content}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
          <a href={buttonLink}>
            <Button label={buttonText} onClick={() => {}} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default FlatSection;
